export const CAMPAIGN_TEMPLATE_SELECTS = {
  messageType: {
    placeholder: 'Message types...',
  },
  sender: {
    placeholder: 'Senders...',
  },
};

// test ids for cloning campaigns
export const CLONING_CAMPAIGNS_ID = 'cloning-campaigns';

// test ids for cloneable campaigns
export const CAMPAIGN_TABLE_ID = 'campaign-table';
export const CAMPAIGN_TABLE_HEADER_ID = 'campaign-table-header';
export const CAMPAIGN_TABLE_COUNT_ID = 'campaign-table-count';
export const CAMPAIGN_TABLE_ROWS_ID = 'campaign-table-rows';

// test ids for each cloneable campaign
export const CAMPAIGN_ID_TEST_ID = 'campaign-id-test-id';
export const CAMPAIGN_NAME_TEST_ID = 'campaign-name-test-id';
export const CAMPAIGN_TEMPLATE_OPTION_TEST_ID = 'campaign-template-option-test-id';
export const MESSAGE_TYPE_TEST_ID = 'message-type-select';
export const SENDER_TEST_ID = 'sender-select';

// test ids for excluded campaigns
export const EXCLUDED_CAMPAIGN_TABLE_ID = 'excluded-campaigns-table';
export const EXCLUDED_CAMPAIGN_TABLE_HEADER_ID = 'excluded-campaigns-table-header';
export const EXCLUDED_CAMPAIGN_TABLE_COUNT_ID = 'excluded-campaigns-table-count';

// test ids for each excluded campaign
export const EXCLUDED_CAMPAIGN_TABLE_ROWS_ID = 'excluded-campaign-table-rows';
export const EXCLUDED_CAMPAIGN_ID_TEST_ID = 'excluded-campaign-id-test-id';
export const EXCLUDED_CAMPAIGN_NAME_TEST_ID = 'excluded-campaign-name-test-id';
export const EXCLUDED_CAMPAIGN_ERROR_TEST_ID = 'excluded-campaign-error-test-id';

// test id for campaigns spinner
export const LOADING_CAMPAIGN_SPINNER = 'loading-campaigns-spinner';

// test id for when there are no cloneable campaigns
export const NO_CLONEABLE_CAMPAIGNS_TEXT = 'no-cloneable-campaigns-text';
